import { render } from "./GetSearchValueInput.vue?vue&type=template&id=cc5c1248"
import script from "./GetSearchValueInput.vue?vue&type=script&lang=js"
export * from "./GetSearchValueInput.vue?vue&type=script&lang=js"
script.render = render

export default script